<template>
  <div class="resume_main">
    <div class="resume_content">
      <div class="resume_m2">
        <div class="head_item resume_item">
          <dl>
            <dd>
              <div class="resume_item_list">

                <div class="img_content"><img
                    :src="archiveinfo?.zp ? archiveinfo.zp : '/base/images/layout/noavatar.png'">
                </div>
              </div>
            </dd>
          </dl>
        </div>
        <div class="info_item resume_item">
          <dl>
            <dt>
              <span class="resume_item_title_span">
                <div class=" resume_item_title">基本信息</div>
              </span>
            </dt>
            <dd>
              <div class="info_content">
                <div class="info_item_list resume_item_list ">
                  <p>民族：<span>{{archiveinfo?.mz}}</span></p>
                </div>
                <div class="info_item_list resume_item_list ">
                  <p>籍贯：<span>{{archiveinfo?.jg}}</span></p>
                </div>
                <div class="info_item_list resume_item_list ">
                  <p>性别：<span>{{archiveinfo?.xb}}</span></p>
                </div>
                <div class="info_item_list resume_item_list ">
                  <p>年龄：<span>{{archiveinfo?.nl}}</span></p>
                </div>
                <!-- <div class="info_item_list resume_item_list ">
                  <span>学历：本科</span>
                </div> -->
                <!-- <div class="info_item_list resume_item_list ">
                  <p>所在城市：<span>武汉</span></p>
                </div> -->
                <!-- <div class="info_item_list resume_item_list ">
                  <p>工作年限：<span>15</span></p>
                </div> -->
                <div class="info_item_list resume_item_list ">
                  <p>联系电话：<span>{{archiveinfo?.lxdh}}</span></p>
                </div>
                <div class="info_item_list resume_item_list ">
                  <p>邮箱：<span>{{archiveinfo?.yx}}</span></p>
                </div>
              </div>
            </dd>
          </dl>
        </div>
        <!-- <div class="skill_item resume_item">
          <dl>
            <dt>
              <span class="resume_item_title_span">
                <div class=" resume_item_title">技能特长</div>
              </span>
            </dt>
            <dd>
              <div class="skill_con">
                <div class="skill_item_list resume_item_list">
                  <span class="skill_title item_title">沟通能力 </span>
                  <span class="skill_slider item_level"><span>熟练</span></span>

                </div>
                <div class="skill_item_list resume_item_list">
                  <span class="skill_title item_title">执行能力 </span>
                  <span class="skill_slider item_level"><span>精通</span></span>

                </div>
                <div class="skill_item_list resume_item_list">
                  <span class="skill_title item_title">学习能力 </span>
                  <span class="skill_slider item_level"><span>熟练</span></span>
                </div>
                <div class="skill_item_list resume_item_list">
                  <span class="skill_title item_title">敬业精神 </span>
                  <span class="skill_slider item_level"><span>精通</span></span>
                </div>
                <div class="skill_item_list resume_item_list">
                  <span class="skill_title item_title">自我管理 </span>
                  <span class="skill_slider item_level"><span>精通</span></span>
                </div>
              </div>
            </dd>
          </dl>
        </div>
        <div class="honor_item resume_item">
          <dl>
            <dt>
              <span class="resume_item_title_span">
                <div class=" resume_item_title">荣誉奖项</div>
              </span>
            </dt>
            <dd>
              <div class="resume_item_list_content resume_item_list">
                <div class="resume_item_list_text">
                  <div class="description">
                    <ul>
                      <li>2019年度优秀销售代理商奖</li>
                      <li>2020年度销售贡献奖</li>
                    </ul>
                  </div>
                </div>
              </div>
            </dd>
          </dl>
        </div> -->
      </div>
      <div class="resume_m3">
        <div class="name_item resume_item base_info_item">
          <dl>
            <dd>
              <div class="name-con">
                <div class="name">{{baseinfo.name}}
                </div>
                <div class="word">
                  部门：<span>{{baseinfo.orgName}}</span>
                  职级：<span>{{baseinfo.zj}}</span>
                  职级名称：<span>{{baseinfo.zjmc}}</span>
                  直属领导：<span>{{baseinfo.zsld}}</span>
                </div>
              </div>
            </dd>
          </dl>
        </div>
        <div class="edu_item time_item resume_item">
          <dl>
            <dt>
              <span class="resume_item_title_span">
                <div class=" resume_item_title">教育经历</div>
              </span>
            </dt>

            <dd v-if="jyList.length">
              <div class="resume_item_list_content resume_item_list " v-for="(item,index) in jyList" :key="index">
                <div class="resume_item_list_title">
                  <span class="time">
                    <div>{{item.qzsj}}</div>
                  </span>
                  <span class="location">
                    <div>{{item.xxmc}}</div>
                  </span>
                  <span class="role">
                    <div>{{item.shzs}}</div>
                  </span>
                </div>
                <!-- <div class="resume_item_list_text">
                  <div class=" description">成绩绩点：3.8，主修课程：市场调研、销售管理、市场营销策略</div>
                </div> -->
              </div>
            </dd>
            <p v-else class="nodata">暂未填写</p>
          </dl>
        </div>
        <div class="exper_item time_item resume_item">
          <dl>
            <dt>
              <span class="resume_item_title_span">
                <div class=" resume_item_title">工作经验</div>
              </span>
            </dt>
            <dd v-if="gzList.length">
              <div class="resume_item_list_content resume_item_list" v-for="(item,index) in gzList" :key="index">
                <div class="resume_item_list_title ">
                  <span class="time">
                    <div>{{item.qzsj}}</div>
                  </span>
                  <span class="location">
                    <div>{{item.gsmc}} </div>
                  </span>
                  <span class="role">
                    <div>{{item.zw}}</div>
                  </span>
                </div>
                <p>{{item.sfzyrwjj}}</p>
                <!-- <div class="resume_item_list_text ">
                  <div class=" description">
                    <ul>
                      <li>负责拓展代理商渠道，达成销售目标。</li>
                      <li>建立并维护与代理商的战略合作关系，提高代理商忠诚度。</li>
                      <li>制定销售计划，分析市场需求，提供定制化销售解决方案。</li>
                      <li>定期与代理商进行培训，确保其了解产品特点和市场趋势。</li>
                    </ul>
                  </div>
                </div> -->
              </div>
            </dd>
            <p v-else class="nodata">暂未填写</p>
          </dl>
        </div>
        <div class="proexper_item time_item resume_item ">
          <dl>
            <dt>
              <span class="resume_item_title_span">
                <div class=" resume_item_title">项目经验</div>
              </span>
            </dt>
            <dd v-if="cyxmlist.length">
              <div class="resume_item_list_content resume_item_list " v-for="(item,index) in cyxmlist" :key="index">
                <div class="resume_item_list_title">
                  <span class="time">
                    <div>{{item.cyxm_cysj}}</div>
                  </span>
                  <span class="location">
                    <div>{{item.cyxm_xmmc}}</div>
                  </span>
                  <span class="role">
                    <div>{{item.cyxm_cyjs}}</div>
                  </span>
                </div>
                <!-- <div class="resume_item_list_text ">
                  <div class=" description">
                    <ul>
                      <li>制定并执行代理商推广计划，提升市场份额。</li>
                      <li>建立代理商销售培训体系，提高代理商销售水平。</li>
                      <li>与代理商共同研发新产品，满足市场需求。</li>
                      <li>成功推动代理商销售额增长30%。</li>
                    </ul>
                  </div>
                </div> -->
              </div>
            </dd>
            <p v-else class="nodata">暂未填写</p>
          </dl>
        </div>
        <div class="peixun_item time_item resume_item ">
          <dl>
            <dt>
              <span class="resume_item_title_span">
                <div class=" resume_item_title">培训经历</div>
              </span>
            </dt>
            <dd v-if="pxjllist.length">
              <div class="resume_item_list_content resume_item_list " v-for="(item,index) in pxjllist" :key="index">
                <div class="resume_item_list_title">
                  <span class="time">
                    <div>{{item.pxjl_pxrq}}</div>
                  </span>
                  <span class="location">
                    <div>{{item.pxjl_pxjg}}</div>
                  </span>
                  <span class="role">
                    <div>{{item.pxjl_pxmc}}</div>
                  </span>
                </div>
                <!-- <div class="resume_item_list_text ">
                  <div class=" description">
                    <ul>
                      <li>制定并执行代理商推广计划，提升市场份额。</li>
                      <li>建立代理商销售培训体系，提高代理商销售水平。</li>
                      <li>与代理商共同研发新产品，满足市场需求。</li>
                      <li>成功推动代理商销售额增长30%。</li>
                    </ul>
                  </div>
                </div> -->
              </div>
            </dd>
            <p v-else class="nodata">暂未填写</p>
          </dl>
        </div>
        <div class="gsnjl_item time_item resume_item ">
          <dl>
            <dt>
              <span class="resume_item_title_span">
                <div class=" resume_item_title">公司内经历</div>
              </span>
            </dt>
            <dd v-if="gsnjllist.length">
              <div class="resume_item_list_content resume_item_list " v-for="(item,index) in gsnjllist" :key="index">
                <div class="resume_item_list_title">
                  <span class="time">
                    <div>{{item.gsnjl_qzrq}}</div>
                  </span>
                  <span class="location">
                    <div>{{item.gsnjl_ssbm}}</div>
                  </span>
                  <span class="role">
                    <div>{{item.gsnjl_zw1}}</div>
                  </span>
                </div>
                <!-- <div class="resume_item_list_text ">
                  <div class=" description">
                    <ul>
                      <li>制定并执行代理商推广计划，提升市场份额。</li>
                      <li>建立代理商销售培训体系，提高代理商销售水平。</li>
                      <li>与代理商共同研发新产品，满足市场需求。</li>
                      <li>成功推动代理商销售额增长30%。</li>
                    </ul>
                  </div>
                </div> -->
              </div>
            </dd>
            <p v-else class="nodata">暂未填写</p>
          </dl>
        </div>
        <!-- <div class="eval_item resume_item">
          <dl>
            <dt>
              <span class="resume_item_title_span">
                <div class=" resume_item_title">自我评价</div>
              </span>
            </dt>
            <dd>
              <div class="resume_item_list_content resume_item_list">
                <div class="resume_item_list_text clearfix">
                  <div class=" description">
                    <ul>
                      <li>对销售工作充满热情，有较强的沟通和谈判能力。</li>
                      <li>具备较强的学习能力，能够快速适应不同市场和产品。</li>
                      <li>注重团队合作，善于与不同背景的人合作。</li>
                      <li>致力于提升客户满意度和公司销售业绩。</li>
                    </ul>
                  </div>
                </div>
              </div>
            </dd>
          </dl>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['loginName', 'baseinfo'],
  data() {
    return {
      archiveinfo: {},
      gzList: [],
      jyList: [],
      cyxmlist: [],
      pxjllist: [],
      gsnjllist: []
    }
  },
  mounted() {
    this.getjyList(this.loginName)
    this.getgzList(this.loginName)
    this.getgsnjllist(this.loginName)
    this.getcyxmlist(this.loginName)
    this.getpxjllist(this.loginName)
    this.getarchiveinfo(this.loginName)
  },
  methods: {
    // 获取教育经历
    getjyList(e) {
      this.$http.post('fighter-apis-manage/apis/query/apis-1714376678585?loginName=' + e).then((res) => {
        this.jyList = res.data
      })
    },
    // 获取工作经历
    getgzList(e) {
      this.$http.post('fighter-apis-manage/apis/query/apis-1714376438000?loginName=' + e).then((res) => {
        this.gzList = res.data
      })
    },
    // 获取公司内经历
    getgsnjllist(e) {
      this.$http.post('fighter-apis-manage/apis/query/apis-1714376380444?loginName=' + e).then((res) => {
        this.gsnjllist = res.data
      })
    },
    // 获取参与项目
    getcyxmlist(e) {
      this.$http.post('fighter-apis-manage/apis/query/apis-1714376292507?loginName=' + e).then((res) => {
        this.cyxmlist = res.data
      })
    },
    // 获取培训经历
    getpxjllist(e) {
      this.$http.post('fighter-apis-manage/apis/query/apis-1714376153513?loginName=' + e).then((res) => {
        this.pxjllist = res.data
      })
    },
    // 获取档案信息
    getarchiveinfo(e) {
      this.$http.post('fighter-apis-manage/apis/query/apis-1714375934200?loginName=' + e).then((res) => {
        // res.data[0]?.sfzh.replace(/(.{6}).*(.{4})/, '$1********$2') || ''
        this.archiveinfo = res.data[0]
      })
    }
  },
  watch: {
    loginName(val, oldval) {
      if (val !== oldval) {
        this.getjyList(val)
        this.getgzList(val)
        this.getgsnjllist(val)
        this.getcyxmlist(val)
        this.getpxjllist(val)
        this.getarchiveinfo(val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.resume_main {
  width: 100%;
  color: #131313;
  height: 100%;
  .resume_content {
    width: 100%;
    height: 100%;
    background: #fff;
    overflow: hidden;
    .resume_m2 {
      float: left;
      width: 20%;
      height: inherit;
      padding-right: 30px !important;
      padding-left: 30px;
      border-right: 2px solid #f0f0f0;
      position: relative;
      .resume_item {
        text-align: left;
        dl dt {
          margin-bottom: 10px !important;
          padding-bottom: 0px !important;
        }
      }
    }
    .resume_m3 {
      float: right;
      width: 65%;
      height: inherit;
      padding-left: 30px !important;
      padding-right: 30px;
      background: #fff;
    }
    .resume_item {
      position: relative;
      border-radius: 4px;
      dt {
        position: relative;
        height: 31px;
        background-color: rgb(240, 240, 240);
        line-height: 31px;
        text-align: center;
        margin-bottom: 10px;
        span.resume_item_title_span {
          float: none;
          font-size: 16px;
          color: #414141;
          display: block;
          text-align: center;
          display: inline-block;
          position: relative;
          word-break: break-word;
          font-weight: bold;
          overflow: hidden;
        }
      }
      dd {
        padding: 0;
        margin: 0;
      }
      .resume_item_list_text {
        position: relative;
        line-height: 1.5;
        word-break: break-word;
        word-wrap: break-word;
        ul {
          padding-left: 15px;
        }
      }
      .resume_item_list_title {
        font-size: 14px;
        span {
          margin: 0;
          /* font-weight: 600; */
          color: #414141;
          display: inline-block;
        }
        .time {
          text-align: left;
          width: 25%;
        }
        .location {
          text-align: center;
          width: 40%;
        }
        .role {
          text-align: right;
          width: 35%;
        }
      }
      .resume_item_list_text .description {
        word-break: break-all;
      }
      .nodata {
        color: #999;
        text-align: center;
      }
    }
    .head_item {
      dd {
        position: relative;
        display: block;
        /* width: 170px; */
        margin: 0 auto;
        /* padding: 20px; */
        border: 1px dashed transparent !important;
      }
      .resume_item_list {
        position: relative;
        width: 128px;
        height: 158px;
        margin: 0 auto;
        border: 4px solid #e5e5e5;
        background: #e5e5e5;
        overflow: hidden;
        cursor: pointer;
      }
      .img_content {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
      .img_content img {
        display: block;
        width: 100%;
      }
    }
    .info_item {
      .info_content {
        .info_item_list {
          position: relative;
          margin: 0 0 10px 0;
          p {
            color: #999;
            span {
              color: #131313;
            }
          }
        }
      }
    }
    .name_item {
      .name-con {
        .name {
          display: inline-block;
          height: 30px;
          line-height: 29px;
          padding-right: 10px;
          font-size: 30px;
          color: #414141;
          width: 100%;
        }
        .word {
          display: block;
          margin-top: 18px;
          line-height: 1.2;
          color: #999;
          span {
            padding-right: 10px;
            color: #131313;
          }
        }
      }
    }
  }
  .skill_item_list {
    display: inline-block;
    position: relative;
    width: 100%;
    height: 40px;
    padding-top: 5px;
    /* margin-right: 40px; */
    margin-bottom: 15px;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
